import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Parser from "html-react-parser";
import Accordion from "../../../components/accordians/accordian";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import "react-toastify/dist/ReactToastify.css";
import { nanoid } from 'nanoid'

import moment from 'moment'
import { useAppContext } from '../../../AppContext';
import { useTheme } from '@mui/material/styles';


function TicketContainer({index, ticket, eventCounterIncrease, eventCounterDecrease}) { 
    
    const theme = useTheme();
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);
    
    const TICKET_TITLE_MAX_LENGTH = 35;
    const cur_date_time = moment(new Date().now).format('yyyy-MM-DD HH:MM');
    let validStatus = 1;
    if (ticket.days_type == 'm') {
        if (moment(ticket.to_date).format('yyyy-MM-DD') + ' ' + ticket.end_time.substring(0,5) < cur_date_time) {
            validStatus = 0;
        }
    }

    if (ticket.days_type == 's') {
        if (moment(ticket.only_today).format('yyyy-MM-DD') + ' ' + ticket.end_time.substring(0,5) < cur_date_time) {
            validStatus = 0;
        }
    }

    
    const ticketContainer = {
        background: theme.palette.background.alternate,
        marginBottom: theme.spacing(2),
        padding: `12px 20px`, 
        border: `1px solid ${theme.palette.background.borderColor}`,
        borderRadius: 3, 
        fontWeight: 100,
        [theme.breakpoints.down("sm")]: {
            padding: `12px 20px`,      
        },
        '& h4': {
            fontFamily: themeCss && themeCss.theme_primary_font ? (themeCss.theme_primary_font).replace("+"," ") : '',
            fontSize: 16,
            color: theme.palette.primary.contrastText,
            fontWeight: 400,
            textTransform: 'capitalize !important',   
            marginTop: theme.spacing(0),
            marginBottom: theme.spacing(0.5),
            [theme.breakpoints.down("md")]: {
                fontSize: 16,      
            },
        },
        '& h5': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 20,
            color: theme.palette.primary.contrastText,
            textTransform: 'capitalize !important',
            fontWeight: 400,
            [theme.breakpoints.down("md")]: {
                fontSize: 18,      
            },
        },
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 12,
            fontWeight: 400,
            color: theme.palette.primary.location,
            marginBottom: theme.spacing(0.5),
        },
        '& .MuiAccordion-root': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            borderTop: 'none',
            color: theme.palette.primary.location,
            '& p': {
                fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
                textTransform: 'capitalize',
                letterSpacing: '0',
                fontWeight: 100,
                fontSize: 12,
                
            },
        },
        '& .MuiAccordionSummary-content': {        
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            margin: 0,
        },    
        '& .MuiAccordionSummary-root': {        
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            minHeight: 0,
        },
        '& .MuiButtonGroup-root': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 10,                
            '& :hover':{                    
                borderColor: '#0de46c',
                color: '#000',
                background: `linear-gradient( 0deg, #37f81b -7.69%, #24f849 28.45%, #00faa0 96.92% )`,
            }
        }
    };

  return (
    <>            
        <Typography component="div" sx={ticketContainer}>            
            <Typography key={nanoid(30)} component="div">
                <Grid container>
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <Typography component="div">
                        <Typography variant="h4">
                            {(ticket.title.length >=
                            TICKET_TITLE_MAX_LENGTH
                                ? ticket.title.toLowerCase().substring(
                                    0,
                                    TICKET_TITLE_MAX_LENGTH
                                ) + " ..."
                                : ticket.title.toLowerCase()
                            )}                        
                        </Typography>
                        <Typography variant="h6">
                            Entry Upto : {ticket.persons} Person(s)
                        </Typography>
                        </Typography>
                    </Grid>
                <>
                    <Grid container                               
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Grid item lg={6} md={6} sm={6} xs={6}>
                            <Typography variant="h5">
                            {ticket.price > 0 ? (
                                <>
                                    <CurrencyRupeeIcon sx={{fontSize:14}}/> {ticket.price}
                                </>
                            ) : (
                                "Free"
                            )}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            sx={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                            }}
                        >
                            <ButtonGroup
                            variant="outlined"
                            aria-label="outlined button group"                        
                            sx={{ alignSelf:'center' }}
                            >
                            {ticket.status == 0 ||
                            ticket.available_qty == 0 ? (
                                <Button disabled>Sold Out</Button>
                            ) : ticket.numberOfTickets < 1 ? (                            
                            <>
                                {validStatus == 0 ? (
                                    <Button disabled>Sold Out</Button>
                                ) : (
                                <Button
                                    variant="contained"
                                    className="themeBtn"
                                    onClick={eventCounterIncrease}
                                    data-event-id={index}
                                    sx={{
                                        minWidth: "75px !important", 
                                        p:0.6, 
                                        fontSize: `14px !important`,
                                        '&.themeBtn':{
                                            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
                                            background: `${themeCss && themeCss.theme_main_color} !important`,
                                            color:`${themeCss && themeCss.theme_primary_font_color} !important`
                                        },
                                    }}
                                    >
                                    {ticket.price > 0 ? "Add" : "RSVP"}
                                    </Button>
                                )}
                            </>
                            ) : (
                                <>
                                <Button
                                    variant="contained"
                                    className="themeBtnRoundedLeft"
                                    onClick={eventCounterDecrease}
                                    data-event-id={index}
                                    sx={{
                                        color: theme.palette.background.default,
                                        fontSize: `14px !important`,
                                        p:0.6,
                                        minWidth:`30px !important`,
                                        height:30,
                                        borderRadius: 50,
                                        '&.themeBtnRoundedLeft':{
                                            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
                                            background: `${themeCss && themeCss.theme_main_color} !important`,
                                            color:`${themeCss && themeCss.theme_primary_font_color} !important`,
                                            borderRadius:30
                                        },
                                    }}
                                >
                                    -
                                </Button>
                                <Button
                                    variant="contained"
                                    className="themeBtnRounded"
                                    sx={{
                                        p:0.6,
                                        '&.themeBtnRounded':{
                                          fontSize: `16px !important`,
                                          color: `${themeCss && themeCss.theme_main_color} !important`,
                                          fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
                                          background: `transparent`,
                                          minWidth:`30px !important`,
                                          height:30,
                                          borderRadius: 50,
                                          m:`auto 3px`,
                                          border:{
                                            md:`1px solid ${themeCss&&themeCss.theme_main_color}`,
                                          },
                                          borderRadius:3,
                                          fontWeight:`900 !important`,
                                          "&:hover":{
                                            background: `transparent`,
                                          }
                                        },
                                      }}
                                    >
                                    {ticket.numberOfTickets}
                                </Button>
                                <Button
                                    variant="contained"
                                    className="themeBtnRoundedRight"
                                    onClick={eventCounterIncrease}
                                    data-event-id={index}
                                    sx={{
                                        color: theme.palette.background.default,
                                        fontSize: `14px !important`,
                                        p:0.6,
                                        minWidth:`30px !important`,
                                        height:30,
                                        borderRadius: 50,
                                        '&.themeBtnRoundedRight':{
                                            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
                                            background: `${themeCss && themeCss.theme_main_color} !important`,
                                            color:`${themeCss && themeCss.theme_primary_font_color} !important`,
                                            borderRadius:30
                                        },
                                    }}
                                >
                                    +
                                </Button>
                                </>
                            )}
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                    <Typography
                    component="div"
                    sx={{                                  
                        width: "100% !important",
                        '& span':{
                            fontSize:12
                        }
                    }}
                    >
                    {ticket.tc && ticket.tc.length > 0 && (
                        <Accordion title="Terms" data={Parser(`${ticket.tc}`)} />
                    )}                   
                    </Typography>
                </>
                </Grid>
            </Typography>
        </Typography>      
    </>
  );
}

export default TicketContainer;

